import { CSSObject } from "@emotion/react";

export const wrapperCss: CSSObject = {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "start",
};

export const formContainerCss = {
  width: "100%",
};

export const titleCss = {
  fontSize: "24px",
  lineHeight: "31,92px",
  fontWeight: "700",
};
